module.exports = __webpack_public_path__ + "assets/aadf74ce83cfc24c5d6eff78d8e00fc6.png";